import moment from "moment";

export const getAge = (dateString: any) => {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  if (age < 0) return 0;
  return age;
}

export const getFormData = (object: any) => {
  const formData = new FormData();

  if (Array.isArray(object)) {
    object.forEach((item, index) => {
      Object.keys(item).forEach((key) => {
        formData.append(`array[${index}][${key}]`, item[key]);
      });
    });
  } else {
    Object.keys(object).forEach((key) => {
      formData.append(key, object[key]);
    });
  }

  return formData;
};

export function alphaOnly(event: any) {
  const key = event.charCode;
  if (key >= 48 && key <= 58) event.preventDefault();
}

export function numOnly(event: any) {
  const key = event.charCode;
  if (key < 48 || key > 58) event.preventDefault();
}

export const checkEventAccpeted = (event: any, userId: any) => {
  if (!event.participants) event.participants = [];
  if (!event.teamA) event.teamA = [];
  if (!event.teamB) event.teamB = [];

  const members = [...event.participants, ...event.teamA, ...event.teamB];

  const member: any = members.find((m: any) => (m?.user?._id === userId));
  return member?.status == 'pending';
}

export function copyTxtToClip(text: any) {
  if (!navigator.clipboard) {
    return;
  }
  navigator.clipboard.writeText(text).then(function () {
  }, function (err) {
    console.error('Async: Could not copy text: ', err);
  });
}

export const checkFileSizeMoreThanTen = (file: any) => {
  return file?.size > 10000000;
}

export const employmentDuration = (joined: any) => {
  const a = moment();
  const b = moment(joined);
  const diffDuration = moment.duration(a.diff(b));
  let duration='';
  const Y= diffDuration.years();
  const M= diffDuration.months();
  const D= diffDuration.days();
  if(Y>0){
    duration += Y + ("Y");
  }
  if(M>0){
    duration += M + ("M");
  }
  if(D>0){
    duration += D + ("D");
  }
  return duration? duration: '0 D';
}

// ========================
// DATE FORMATTING UTILITIES
// ========================

/**
 * Format booking time exactly as stored in database (no timezone conversion)
 * Displays database time (e.g., "2025-09-22T19:00:19.667Z") as "Sep 22, 2025, 07:00 PM"
 * @param checkinTime - ISO string from database
 * @returns Formatted date string or "-" if invalid
 */
export const formatBookingTime = (checkinTime: any): string => {
  if (!checkinTime) return "-";
  
  try {
    // Extract date and time parts directly from the ISO string
    const isoString = checkinTime.toString();
    const [datePart, timePart] = isoString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':');
    
    // Convert to 12-hour format
    const hourNum = parseInt(hour);
    const hour12 = hourNum === 0 ? 12 : hourNum > 12 ? hourNum - 12 : hourNum;
    const ampm = hourNum >= 12 ? 'PM' : 'AM';
    
    // Format month name
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthName = monthNames[parseInt(month) - 1];
    
    return `${monthName} ${parseInt(day)}, ${year}, ${hour12.toString().padStart(2, '0')}:${minute} ${ampm}`;
  } catch (error) {
    console.error('Error formatting booking time:', error);
    return "-";
  }
};

/**
 * Legacy alias for backwards compatibility
 * @deprecated Use formatBookingTime instead
 */
export const formatCheckinTime = formatBookingTime;

export const to12h = (time: string): string => {
  if (!time) return '';
  const [h, m] = time.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour = h % 12 || 12;
  return `${hour}:${String(m).padStart(2, '0')} ${period}`;
};
